import { render, staticRenderFns } from "./AddScrap.vue?vue&type=template&id=74876d84&"
import script from "./AddScrap.vue?vue&type=script&lang=js&"
export * from "./AddScrap.vue?vue&type=script&lang=js&"
import style0 from "./AddScrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports